
export const useRawPageData = () => {
  const transform = (response) => {
    const { sanitize } = useUtils();
    const data = response?.data || {};
    const attributes = data?.attributes || {};
    return {
      id: data?.id ?? null,
      title: sanitize(attributes.title),
      slug: sanitize(attributes.slug),
      content: sanitize(attributes.content),
      jumpToTop: sanitize(attributes.jumpToTop),
      seo: sanitize(attributes.seo)
    }
  }
  
  const getRawPageBySlug = async (slug) => {    
    const {findOneBySlug} = useStrapiAsyncData();
    const url = 'raw-pages';
    const params = {
      slug: slug,
      entity: 'raw-pages'
    }
    return findOneBySlug(url, params, transform);
  }

  const getCompanyPage = async (id) => {
    return await useFetch(`/api/company-configurable-text?configTypeId=${id}`, {
      method: 'GET',
    })
  }

  /** Use for lazy/client-only loads (e.g. modals). Avoids useFetch outside setup and skips Nuxt payload serialization. */
  const fetchCompanyConfigurableText = async (id) => {
    const path = `/api/company-configurable-text?configTypeId=${id}`
    return await $fetch(path, { method: 'GET' })
  }

  return {
    getRawPageBySlug,
    getCompanyPage,
    fetchCompanyConfigurableText,
  }
}